<div class="f-as w-100p"><celebration-programs-form-custom-preview :schedule="modal.data.schedule"></celebration-programs-form-custom-preview></div>